export const COVERTREE_PHONE_NUMBER = "(877) 417-8733";
export const COVERTREE_EMAIL_ADDRESS = "help@covertree.com";
export const SALES_EMAIL_ADDRESS = "agentsales@covertree.com";
